import { datadogRum } from "@datadog/browser-rum";
const DEFAULT_ALLOWED_TRACING_URLS = [
    {
        match: (url) => url.startsWith("https://api.notemeal.io/"),
        propagatorTypes: ["datadog"],
    },
];
export const initDatadogRum = ({ applicationId, clientToken, service, version, datadogEnv, commit, site = "datadoghq.com", sessionReplaySampleRate = 20, defaultPrivacyLevel = "allow", allowedTracingUrls = DEFAULT_ALLOWED_TRACING_URLS, }) => {
    console.info("initializing datadog RUM");
    datadogRum.init({
        applicationId,
        clientToken,
        service,
        version,
        env: datadogEnv,
        site,
        sessionSampleRate: 100,
        sessionReplaySampleRate,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        trackFrustrations: true,
        defaultPrivacyLevel,
        allowedTracingUrls,
    });
    datadogRum.startSessionReplayRecording();
    datadogRum.setGlobalContextProperty("commit", commit);
    console.info("done initializing datadog RUM");
};
//# sourceMappingURL=reporting-datadog-rum.js.map